import { NotAuthorizedComponent } from './../shared/components/not-authorized/not-authorized.component';
import { AspRoles, AspSalesAdminRoles, AspServiceAdminRoles, DD365Roles, DD365DistRoles } from './../shared/services/util.service';
// import { DashboardModule } from './../dashboard/dashboard.module';
import { LayoutComponent } from './layout.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SalesModule } from '../sales/sales.module';
import { ServiceModule } from '../service/service.module';
import { PartsModule } from '../parts/parts.module';
import { BdcModule } from '../bdc/bdc.module';
import { CorporateAppointmentDashboardModule } from '../corporate-appointment-dashboard/corporate-appointment-dashboard.module';
import { aspAuthenticationGuardService } from '../shared/guards/auth.guard';
import { DeliveryChecklistModule } from '../delivery-checklist/delivery-checklist.module';
import { ProtectRoute } from '../shared/guards/protect-route.guard';

const routes: Routes = [

    {
        path: '',
        component: LayoutComponent,
        data: { roles: [...DD365Roles, ...DD365DistRoles], roleCheck: 'OR' },
        canActivate: [aspAuthenticationGuardService],
        children: [
            {
                path: '',
                redirectTo: 'bdc',
                pathMatch: 'full'
            },
            // {
            //     path: 'dashboard',
            //     loadChildren: () => DashboardModule
            // },
            {
                path: 'parts',
                loadChildren: () => PartsModule,
                data: { roles: AspRoles, roleCheck: 'AND' },
                canActivate: [ProtectRoute],
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'sales',
                loadChildren: () => SalesModule,
                data: { roles: [...AspRoles, ...AspSalesAdminRoles], roleCheck: 'AND' },
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'service',
                loadChildren: () => ServiceModule,
                data: { roles: [...AspRoles, ...AspServiceAdminRoles], roleCheck: 'AND' },
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'bdc',
                loadChildren: () => BdcModule,
                data: { roles: AspRoles, roleCheck: 'AND' },
                canActivate:[ProtectRoute],
                canActivateChild: [aspAuthenticationGuardService],
            },
            {
                path: 'deliveryChecklist',
                loadChildren: () => DeliveryChecklistModule,
                data: { roles: [...DD365Roles, ...DD365DistRoles], roleCheck: 'OR' },
                canActivate: [ProtectRoute],
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'corporateDashboard',
                loadChildren: () => CorporateAppointmentDashboardModule,
                data: { roles: [...AspRoles], roleCheck: 'OR' },
                canActivate: [ProtectRoute],
                canActivateChild: [aspAuthenticationGuardService]
            }
        ]
    },
    {
        path: 'not-authorized',
        component: NotAuthorizedComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LayoutRoutingModule { }